// extracted by mini-css-extract-plugin
module.exports = {"CurriculumsWrap":"Curriculums_CurriculumsWrap__8EtV9","TitleWarrper":"Curriculums_TitleWarrper__3P9tL","Curriculums":"Curriculums_Curriculums__MMVHq"};